import { CARD_SIZE } from '@wix/communities-forum-client-commons';
import { CardSizes } from './Settings/constants/card-sizes';

export const stylesParamsDefaults = {
  [CARD_SIZE]: () => CardSizes.MEDIUM,
};
